import React from "react";
import { Dialog } from "@vitalsource/vstui";
import Isvg from "../../../vendor/react-inlinesvg";

const LearnerModal = ({ closeModal }) => (
  <Dialog
    open
    key="AutoSharingLearnerModal"
    rootSelector="#bookshelf"
    size="medium"
    onRequestClose={closeModal}
    title={i18n.t(`auto-assign.learner-handoff-title`)}
    primaryActionButton={{
      label: i18n.t("main-menu.got-it", "Got It"),
      onClick: closeModal
    }}
  >
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <Isvg className="watkins" src="/img/highlighters_null.svg" />
    </div>
    <p>{i18n.t(`auto-assign.learner-handoff-text`)}</p>
  </Dialog>
);

export default LearnerModal;
